<template>
  <div>
    <el-upload
      action="/api/common/qiniu/upload"
      :limit="1"
      list-type="picture-card"
      class="imgWrap"
      :on-preview="handlePictureCardPreview"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      :on-remove="handleRemove"
      :file-list="fileList"
      accept="image/jpeg, image/png, image/gif"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisibleUrl" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  props:{
    value:{
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fileList: this.value || [],
      dialogImageUrl: "",
      dialogVisibleUrl: false,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.fileList = newVal || [];
      },
      deep: true
    }
  },
  beforeDestroy() {
    this.fileList = []; // 清除文件列表，防止内存泄漏
  },
  methods: {
    beforeAvatarUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error("上传文件大小不能超过 50MB!");
      }
      return isLt50M;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleUrl = true;
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code == 1) {
        this.fileList = fileList.map((item) => {
          return {
            url: item.response.data.all_path_url || item.url,
            name: item.name,
          };
        });
      } else {
        this.$message({
          type: "error",
          message: res.msg,
        });
      }
      this.sendData();
    },
    handleRemove(file, fileList) {
      this.fileList = fileList.map((item) => {
        return {
          url: item.url || item.response.data.all_path_url,
          name: item.name,
        };
      });
      this.sendData();
    },
    sendData() {
      this.$emit("input", this.fileList); // 添加这行以支持v-model
    }
  },
};
</script>
<style lang="scss" scoped>
.imgWrap {
  width: 90px;
  overflow: hidden;
  height: 80px;
}
.imgWrap ::v-deep .el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.imgWrap ::v-deep .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
}
.label-ell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 120px;
}
</style>